import Markdown from 'preact-markdown'

import { IconInfo } from '../icons/info'
import s from './warning-message.sass'

const WarningMessage = ({
  icon = <IconInfo />,
  message
}) => (
  <div className={s.warning}>
    <Markdown markdown={message || ''} />
  </div>
)

export default WarningMessage



// WEBPACK FOOTER //
// ./components/signup-flow/warning-message.js